export function initSlider(config: {
    modalId: string;
    viewportId: string;
    trackId: string;
    btnLeftId: string;
    btnRightId: string;
    visibleLg?: number;
    visibleMd?: number;
    visibleSm?: number;
    disableOnMobile?: boolean;
}) {
    const modal = document.querySelector(`app-modal[modal-id="${config.modalId}"]`);
    if (!modal) return;

    let currentIndex = 0;

    const getVisibleSlides = () => {
        if (window.innerWidth >= 1024) return config.visibleLg ?? 3;
        if (window.innerWidth >= 768) return config.visibleMd ?? 2;
        return config.visibleSm ?? 1;
    };

    const updateSlider = () => {
        const track = document.getElementById(config.trackId);
        const btnLeft = document.getElementById(config.btnLeftId);
        const btnRight = document.getElementById(config.btnRightId);
        const gap = config.modalId === "img-referencial" ? 16 : 0;

        if (!track || !btnLeft || !btnRight) return;

        const visible = getVisibleSlides();
        const total = track.children.length;
        const maxIndex = Math.max(0, total - visible);

        const isMobile = window.innerWidth < 768;
        if (config.disableOnMobile && isMobile) {
            track.style.transform = "none";
            return;
        }

        if (currentIndex > maxIndex) currentIndex = maxIndex;
        if (currentIndex < 0) currentIndex = 0;

        const slideItem = track.querySelector(".slide-item");
        if (slideItem) {
            const itemWidth = slideItem.getBoundingClientRect().width;
            const translateX = (currentIndex * itemWidth) + (gap * currentIndex);
            track.style.transform = `translateX(-${translateX}px)`;
        }

        // Button status
        btnLeft.style.opacity = currentIndex === 0 ? "0.2" : "1";
        btnLeft.style.pointerEvents = currentIndex === 0 ? "none" : "auto";
        btnRight.style.opacity = currentIndex === maxIndex ? "0.2" : "1";
        btnRight.style.pointerEvents = currentIndex === maxIndex ? "none" : "auto";
    };

    const setupEvents = () => {
        const btnLeft = document.getElementById(config.btnLeftId);
        const btnRight = document.getElementById(config.btnRightId);

        if (!btnLeft || !btnRight) return;

        // Remove existing listeners by cloning
        const newBtnLeft = btnLeft.cloneNode(true) as HTMLButtonElement;
        const newBtnRight = btnRight.cloneNode(true) as HTMLButtonElement;
        btnLeft.parentNode?.replaceChild(newBtnLeft, btnLeft);
        btnRight.parentNode?.replaceChild(newBtnRight, btnRight);

        newBtnLeft.addEventListener("click", () => {
            if (currentIndex > 0) {
                currentIndex--;
                updateSlider();
            }
        });

        newBtnRight.addEventListener("click", () => {
            const track = document.getElementById(config.trackId);
            if (!track) return;
            const visible = getVisibleSlides();
            const total = track.children.length;
            const maxIndex = Math.max(0, total - visible);
            if (currentIndex < maxIndex) {
                currentIndex++;
                updateSlider();
            }
        });

        updateSlider();
    };

    window.addEventListener("resize", () => {
        updateSlider();
    });

    modal.addEventListener("open", () => {
        currentIndex = 0;
        setupEvents();
        setTimeout(updateSlider, 150);
    });
}
